import { Box, InputLabel, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DayTimeSelector from '../day-time-selector/day-time-selector.component';
import TodayOrScheduleSelector from '../today-or-schedule-selector/today-or-schedule-selector.component';
import { useFieldNames } from '../useFieldNames.hooks';
import { useScheduleOrder } from './schedule-order.hooks';
import FutureOrderBanner from '../future-order-banner/future-order-banner.component';
import { useEffect, useRef } from 'react';

const ScheduleOrder = props => {
  const { orderTypeLabel, isSevenPlusDayOrderingEnabled, ...dayTimeProps } =
    useScheduleOrder(props);
  const { fieldNames } = useFieldNames();
  const { t } = useTranslation();
  const headingRef = useRef();

  useEffect(() => {
    setTimeout(() => {
      headingRef.current?.focus();
    }, 100);
  }, []);

  return (
    <Box position="relative" minHeight="200px">
      <FutureOrderBanner
        isTodayOff={dayTimeProps.isTodayOff}
        store={props.store}
      />
      <InputLabel htmlFor={fieldNames.day}>
        <Typography
          component="h3"
          variant="h6"
          gutterBottom
          ref={headingRef}
          tabIndex={-1}
        >
          {t('locations.card.selectDayTime', {
            orderTypeLabel,
          })}
        </Typography>

        {isSevenPlusDayOrderingEnabled ? (
          <TodayOrScheduleSelector {...dayTimeProps} {...props} />
        ) : (
          <Box maxHeight="450px" overflow="hidden">
            <DayTimeSelector {...dayTimeProps} {...props} />
          </Box>
        )}
      </InputLabel>
    </Box>
  );
};

export default ScheduleOrder;
